import { ContactCard } from 'components/ContactCard'
import { MobileInfiniteScrollView } from 'components/MobileInfiniteScrollView'
import { ContactListResponse, ContactResponse } from 'models/contacts'
import apiService from 'services/api'

type Props = {
  page: number
  filterAndSortParams: Record<string, unknown>
  onEdit: (contact: ContactResponse) => void
}

export function MobileContactList({
  page,
  filterAndSortParams,
  onEdit,
}: Props) {
  const api = apiService()

  const query = api.useGetContactsInfinite({
    page,
    page_size: 10,
    ...filterAndSortParams,
  })

  return (
    <MobileInfiniteScrollView<ContactListResponse, ContactResponse>
      extractItems={(page) => page.results}
      infiniteQuery={query}
    >
      {(items) =>
        items?.map((contact: ContactResponse) => (
          <ContactCard key={contact.id} contact={contact} onEdit={onEdit} />
        ))
      }
    </MobileInfiniteScrollView>
  )
}
